import classNames from 'classnames';
import React from 'react';
import styles from './StepExpanded.module.scss';

export interface ElementWithClassName {
  className?: string;
}

const StepExpanded: React.FC<ElementWithClassName> = ({
  children,
  className,
}) => (
  <div className={classNames(styles['step-expanded-container'], className)}>
    {children}
  </div>
);

export default StepExpanded;
